import { useTranslation } from 'react-i18next';

import { AzimutLogo } from '@/app/components/AzimutLogo';
import { MicrosoftSignInButton } from '@/auth/components/MicrosoftSignInButton';
import { useAuth } from '@/auth/hooks/useAuth';

export default function LoginPage() {
  const { t } = useTranslation('auth');

  const { login, inProgress } = useAuth();

  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  const isLoading = inProgress !== 'none';

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-md space-y-8 px-4">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <AzimutLogo width={200} />
          </div>
          <h2 className="text-3xl font-bold tracking-tight">
            {t('login.title')}
          </h2>
          <p className="mt-2 text-sm text-muted-foreground">
            {t('login.subtitle')}
          </p>
        </div>

        <div className="mt-8 space-y-6">
          <MicrosoftSignInButton onClick={handleLogin} isLoading={isLoading} />

          <p className="text-center text-xs text-muted-foreground">
            {t('login.footer')}
          </p>
        </div>
      </div>
    </div>
  );
}
